import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Button,
  Box,
  TextField,
  Input,
  Autocomplete,
  Modal,
  CircularProgress,
  InputAdornment,
  Menu,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import Resizer from "react-image-file-resizer";
import AlertMessage from "./modules/AlertMessage";
import { baseUrl } from "./modules/general";
import axios from "axios";
import { usePrice } from "./modules/PhonePriceListContext";
import SearchIcon from "@mui/icons-material/Search";

let imageFile = "";
let imageResize1 = null;
let imageResize2 = null;
let imageResize3 = null;
let imageResize4 = null;
export default function AddProduct() {
  const { t, i18n } = useTranslation();
  const { phoneData, laptopData, gameData, tabletData, dasteData, modemData } =
    usePrice();
  const [alert, setAlert] = useState({
    alertCheck: false,
    message: "",
    severity: "",
  });
  const [model, setModel] = useState("");
  const [brand, setBrand] = useState("");
  const [group, setGroup] = useState("");
  const [region, setRegion] = useState("");
  const [size, setSize] = useState("");
  const [color, setColor] = useState("");
  const [proccess, setProccess] = useState("");
  const [os, setOs] = useState("");
  const [network, setNetwork] = useState("");
  const [year, setYear] = useState("");
  const [weight, setWeight] = useState("");
  const [sim, setSim] = useState("");
  const [display, setDisplay] = useState("");
  const [ram, setRam] = useState("");
  const [zarfiat, setZarfiat] = useState("");
  const [graphic, setGraphic] = useState("");
  const [mainCameraResolution, setMainCameraResolution] = useState("");
  const [mainCameraFeature, setMainCameraFeature] = useState("");
  const [mainCameraVideo, setMainCameraVideo] = useState("");
  const [selfiCameraResolution, setSelfiCameraResolution] = useState("");
  const [selfiCameraFeature, setSelfiCameraFeature] = useState("");
  const [selfiCameraVideo, setSelfiCameraVideo] = useState("");
  const [battery, setBattery] = useState("");
  const [charge, setCharge] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [title_fa, setTitle_fa] = useState("");
  const [title_en, setTitle_en] = useState("");
  const [h1_fa, setH1_fa] = useState("");
  const [h1_en, setH1_en] = useState("");
  const [desc_fa, setDesc_fa] = useState("");
  const [desc_en, setDesc_en] = useState("");
  const [keyword_fa, setKeyword_fa] = useState("");
  const [keyword_en, setKeyword_en] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [addModel, setAddModel] = useState("");
  const [addBrand_fa, setAddBrand_fa] = useState("");
  const [addBrand_en, setAddBrand_en] = useState("");
  const [addDesc, setAddDesc] = useState("");
  const [addGroup_fa, setAddGroup_fa] = useState("");
  const [addGroup_en, setAddGroup_en] = useState("");
  const [addRegion_fa, setAddRegion_fa] = useState("");
  const [addRegion_en, setAddRegion_en] = useState("");
  const [addSize, setAddSize] = useState("");
  const [addPixel, setAddPixel] = useState("");
  const [addColor_fa, setAddColor_fa] = useState("");
  const [addColor_en, setAddColor_en] = useState("");
  const [addHex, setAddHex] = useState("");
  const [img1, setImg1] = useState(null);
  const [img2, setImg2] = useState(null);
  const [img3, setImg3] = useState(null);
  const [img4, setImg4] = useState(null);
  const [modelData, setModelData] = useState(null);
  const [brandData, setBrandData] = useState(null);
  const [groupData, setGroupData] = useState(null);
  const [regionData, setRegionData] = useState(null);
  const [sizeData, setSizeData] = useState(null);
  const [colorData, setColorData] = useState(null);
  const [btnDis, setBtnDis] = useState(false);
  const [loading, setLoading] = useState(false);
  const [proDis, setProDis] = useState(false);
  const [groupId, setGroupId] = useState("");
  const [brandId, setBrandId] = useState("");
  const [modelId, setModelId] = useState("");
  const [regionId, setRegionId] = useState("");
  const [sizeId, setSizeId] = useState("");
  const [colorId, setColorId] = useState("");
  const [product, setProduct] = useState("");
  const proData =
    group.id === 1
      ? phoneData
      : group.id === 2
        ? laptopData
        : group.id === 3
          ? tabletData
          : group.id === 4
            ? gameData
            : group.id === 6
              ? dasteData
              : group.id === 7
                ? modemData
                : [];
  const productSelect =
    groupData === null && proData.length === 0
      ? []
      : proData.map((item) => ({
          value: `${item.hdd === null ? "" : item.hdd}_${item.model.name}_${item.color.name_fa}_${item.ram === null ? "" : item.ram}`,
          id: item.id,
        }));

  useEffect(() => {
    const props = ["M", "B", "G", "R", "S", "C"];
    props.forEach((prop) => {
      getProductData(prop);
    });
  }, []);

  const getProductData = (prp) => {
    Promise.resolve(
      axios({
        url: baseUrl + "/api/v1/product/get",
        method: "GET",
        params: {
          prop: prp,
        },
      }),
    )
      .then((res) => {
        switch (prp) {
          case "M":
            setModelData(res.data.data);
            break;
          case "B":
            setBrandData(res.data.data);
            break;
          case "G":
            setGroupData(res.data.data);
            break;
          case "R":
            setRegionData(res.data.data);
            break;
          case "S":
            setSizeData(res.data.data);
            break;
          case "C":
            setColorData(res.data.data);
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        const { status } = error.response;
        status === 500
          ? setAlert({
              alertCheck: true,
              message: t("AM_intervalServer"),
              severity: "error",
            })
          : setAlert({
              alertCheck: true,
              message: t("alert_dataFaild"),
              severity: "error",
            });
      });
  };

  const modelSelect =
    modelData === null
      ? []
      : modelData.map((item) => ({
          value: item.name,
          id: item.id,
        }));

  const brandSelect =
    brandData === null
      ? []
      : brandData.map((item) => ({
          value: i18n.language === "fa" ? item.name_fa : item.name_en,
          id: item.id,
        }));

  const groupSelect =
    groupData === null
      ? []
      : groupData.map((item) => ({
          value: i18n.language === "fa" ? item.name_fa : item.name_en,
          id: item.id,
        }));

  const regionSelect =
    regionData === null
      ? []
      : regionData.map((item) => ({
          value: i18n.language === "fa" ? item.name_fa : item.name_en,
          id: item.id,
        }));

  const sizeSelect =
    sizeData === null
      ? []
      : sizeData.map((item) => ({
          value: `${item.inch} _ ${item.pixel}`,
          id: item.id,
        }));

  const colorSelect =
    colorData === null
      ? []
      : colorData.map((item) => ({
          value: i18n.language === "fa" ? item.name_fa : item.name_en,
          id: item.id,
        }));

  const clickOtherLocation = (e) => {
    if (e.target.id === "modal-status") {
      closeModal();
    }
  };

  const openModalHandler = (type) => {
    setOpenModal(true);
    setModalType(type);
  };

  const closeModal = () => {
    setOpenModal(false);
    setModalType("");
    setAddModel("");
    setAddBrand_fa("");
    setAddBrand_en("");
    setAddGroup_fa("");
    setAddGroup_en("");
    setAddRegion_fa("");
    setAddRegion_en("");
    setAddSize("");
    setAddColor_fa("");
    setAddColor_en("");
    setAddDesc("");
    setAddPixel("");
    setAddHex("");
  };

  const onChangeLicence = (e, IMG) => {
    if (e.target.files[0]) {
      imageFile = e.target.files[0];
      if (imageFile.size > 1000000) {
        setAlert({
          alertCheck: true,
          message: t("alert_picSize"),
          severity: "error",
        });
      } else {
        imageResizer(IMG);
      }
    }
  };

  const imageResizer = (data) => {
    try {
      Resizer.imageFileResizer(
        imageFile,
        870,
        580,
        "JPEG",
        100,
        0,
        (uri) => {
          let reader = new FileReader();
          reader.readAsDataURL(uri);
          reader.onload = () => {
            data === "IMG1"
              ? setImg1(reader.result)
              : data === "IMG2"
                ? setImg2(reader.result)
                : data === "IMG3"
                  ? setImg3(reader.result)
                  : data === "IMG4" && setImg4(reader.result);
          };
          data === "IMG1"
            ? (imageResize1 = uri)
            : data === "IMG2"
              ? (imageResize2 = uri)
              : data === "IMG3"
                ? (imageResize3 = uri)
                : data === "IMG4" && (imageResize4 = uri);
        },
        "file",
      );
    } catch (err) {
      setAlert({
        alertCheck: true,
        message: t("alert_notPic"),
        severity: "error",
      });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    return setAlert({
      alertCheck: false,
      message: "",
      severity: alert.severity,
    });
  };

  const submitHandler = (type) => {
    switch (type) {
      case "addModel":
        if (addModel === "") {
          setAlert({
            alertCheck: true,
            message: t("enterInformation"),
            severity: "error",
          });
        } else {
          addButton(type);
        }
        break;
      case "addGroup":
        if (addGroup_en === "" || addGroup_fa === "") {
          setAlert({
            alertCheck: true,
            message: t("enterInformation"),
            severity: alert.severity,
          });
        } else {
          addButton(type);
        }
        break;
      case "addBrand":
        if (addBrand_en === "" || addBrand_fa === "") {
          setAlert({
            alertCheck: true,
            message: t("enterInformation"),
            severity: alert.severity,
          });
        } else {
          addButton(type);
        }
        break;
      case "addRegion":
        if (addRegion_en === "" || addRegion_fa === "") {
          setAlert({
            alertCheck: true,
            message: t("enterInformation"),
            severity: alert.severity,
          });
        } else {
          addButton(type);
        }
        break;
      case "addSize":
        if (addSize === "" && addPixel === "") {
          setAlert({
            alertCheck: true,
            message: t("enterInformation"),
            severity: alert.severity,
          });
        } else {
          addButton(type);
        }
        break;
      default:
        break;
    }
  };

  const addButton = (type) => {
    const formData = new FormData();
    let data = {};
    switch (type) {
      case "addModel":
        data = {
          name: addModel,
          prop: "M",
        };
        break;
      case "addGroup":
        data = {
          en: addGroup_en,
          fa: addGroup_fa,
          prop: "G",
        };
        break;
      case "addBrand":
        if (addDesc !== "") {
          formData.append("des", addDesc);
        }
        formData.append("en", addBrand_en);
        formData.append("fa", addBrand_fa);
        formData.append("prop", "B");
        break;
      case "addRegion":
        data = {
          en: addRegion_en,
          fa: addRegion_fa,
          prop: "R",
        };
        break;
      case "addSize":
        // data = {
        //   in: addSize,
        //   pixel: addPixel,
        //   prop: "S"
        // };
        if (addPixel !== "") {
          formData.append("pixel", addPixel);
        }
        formData.append("in", addSize);
        formData.append("prop", "S");
        break;
      default:
        break;
    }
    setLoading(true);
    setBtnDis(true);
    const AuthStr = "bearer " + localStorage.getItem("TACC");
    Promise.resolve(
      axios({
        url: baseUrl + "/api/v1/product/set",
        method: "POST",
        headers: {
          Authorization: AuthStr,
          "Content-Type": "multipart/form-data",
        },
        data: type === "addBrand" || type === "addSize" ? formData : data,
      }),
    )
      .then((res) => {
        setAlert({ alertCheck: true, message: "ثبت شد", severity: "success" });
        setBtnDis(false);
        setLoading(false);
        setAddModel("");
        setAddGroup_en("");
        setAddGroup_fa("");
        setAddBrand_en("");
        setAddBrand_fa("");
        setAddDesc("");
        setAddRegion_en("");
        setAddRegion_fa("");
        setAddSize("");
        setAddPixel("");
        if (type === "addModel") {
          if (res.data.data === true) {
            getProductData("M");
          }
        } else if (type === "addGroup") {
          if (res.data.data === true) {
            getProductData("G");
          }
        } else if (type === "addBrand") {
          if (res.data.data === true) {
            getProductData("B");
          }
        } else if (type === "addRegion") {
          if (res.data.data === true) {
            getProductData("R");
          }
        } else if (type === "addSize") {
          if (res.data.data === true) {
            getProductData("S");
          }
        }
        closeModal();
      })
      .catch((error) => {
        const { status } = error.response;
        switch (status) {
          case 500:
            setAlert({
              alertCheck: true,
              message: t("AM_intervalServer"),
              severity: "error",
            });
            break;
          case 400:
            setAlert({
              alertCheck: true,
              message: "درخواست نامعتبر است،لطفا فیلدها را مجددا چک کنید",
              severity: "error",
            });
            break;
          default:
            setAlert({
              alertCheck: true,
              message: t("alert_defualt"),
              severity: "error",
            });
        }
        setBtnDis(false);
        setLoading(false);
      });
  };

  const onchangeGroup = (event, newSelection) => {
    setGroup(newSelection);
    setGroupId(newSelection ? newSelection.id : "");
    setProduct("");
    setColor("");
    setOs("");
    setProccess("");
    setNetwork("");
    setYear("");
    setWeight("");
    setSim("");
    setDisplay("");
    setRam("");
    setZarfiat("");
    setGraphic("");
    setMainCameraFeature("");
    setMainCameraResolution("");
    setMainCameraVideo("");
    setSelfiCameraFeature("");
    setSelfiCameraResolution("");
    setSelfiCameraVideo("");
    setBattery("");
    setCharge("");
    setBrand("");
    setRegion("");
    setSize("");
    setModel("");
  };

  const onchangeBrand = (event, newSelection) => {
    setBrand(newSelection);
    setBrandId(newSelection ? newSelection.id : "");
  };

  const onchangeModel = (event, newSelection) => {
    setModel(newSelection);
    setModelId(newSelection ? newSelection.id : "");
  };

  const onchangeRegion = (event, newSelection) => {
    setRegion(newSelection);
    setRegionId(newSelection ? newSelection.id : "");
  };

  const onchangeSize = (event, newSelection) => {
    setSize(newSelection);
    setSizeId(newSelection ? newSelection.id : "");
  };

  const onchangeColor = (event, newSelection) => {
    setColor(newSelection);
    setColorId(newSelection ? newSelection.id : "");
  };

  const convertCapital = (str) => {
    if (typeof str !== "string" || str.length === 0) {
      return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const addProduct = () => {
    setLoading(true);
    setProDis(true);
    const formData = new FormData();
    if (groupId !== "") {
      formData.append("group", groupId);
    }
    if (modelId !== "") {
      formData.append("model", modelId);
    }
    if (brandId !== "") {
      formData.append("brand", brandId);
    }
    if (regionId !== "") {
      formData.append("regin", regionId);
    }
    if (colorId !== "") {
      formData.append("color", colorId);
    }
    if (sizeId !== "") {
      formData.append("size", sizeId);
    }
    if (proccess !== "") {
      formData.append("proccess", proccess);
    }
    if (os !== "") {
      formData.append("os", os);
    }
    if (network !== "") {
      formData.append("network", network);
    }
    if (year !== "") {
      formData.append("lunch", year);
    }
    if (weight !== "") {
      formData.append("weight", weight);
    }
    if (sim !== "") {
      formData.append("sim", sim);
    }
    if (display !== "") {
      formData.append("type_display", display);
    }
    if (ram !== "") {
      formData.append("ram", ram);
    }
    if (zarfiat !== "") {
      formData.append("hdd", zarfiat);
    }
    if (graphic !== "") {
      formData.append("vga", graphic);
    }
    if (mainCameraResolution !== "") {
      formData.append("main_camera_mou", mainCameraResolution);
    }
    if (mainCameraFeature !== "") {
      formData.append("main_camera_fea", mainCameraFeature);
    }
    if (mainCameraVideo !== "") {
      formData.append("main_camera_vid", mainCameraVideo);
    }
    if (selfiCameraResolution !== "") {
      formData.append("selfi_camera_mou", selfiCameraResolution);
    }
    if (selfiCameraFeature !== "") {
      formData.append("selfi_camera_fea", selfiCameraFeature);
    }
    if (selfiCameraVideo !== "") {
      formData.append("selfi_camera_vid", selfiCameraVideo);
    }
    if (battery !== "") {
      formData.append("battery", battery);
    }
    if (charge !== "") {
      formData.append("charging", charge);
    }
    if (price !== "") {
      formData.append("price", price);
    }
    if (title_fa !== "") {
      formData.append("title_fa", title_fa);
    }
    if (title_en !== "") {
      formData.append("title_en", title_en);
    }
    if (description !== "") {
      formData.append("des", description);
    }
    if (h1_en !== "") {
      formData.append("h1_en", h1_en);
    }
    if (h1_fa !== "") {
      formData.append("h1_fa", h1_fa);
    }
    if (desc_en !== "") {
      formData.append("des_seo_en", desc_en);
    }
    if (desc_fa !== "") {
      formData.append("des_seo_fa", desc_fa);
    }
    if (keyword_en !== "") {
      formData.append("key_en", keyword_en);
    }
    if (keyword_fa !== "") {
      formData.append("key_fa", keyword_fa);
    }
    formData.append("prop", "P");

    const AuthStr = "bearer " + localStorage.getItem("TACC");
    Promise.resolve(
      axios({
        url: baseUrl + "/api/v1/product/set",
        method: "POST",
        headers: {
          Authorization: AuthStr,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }),
    )
      .then((res) => {
        setLoading(true);
        setProDis(true);
        if (res.data.data) {
          sendImage(res.data.data);
        }
      })
      .catch((error) => {
        const { status } = error.response;
        switch (status) {
          case 500:
            setAlert({
              alertCheck: true,
              message: t("AM_intervalServer"),
              severity: "error",
            });
            break;
          case 400:
            setAlert({
              alertCheck: true,
              message: "درخواست نامعتبر است،لطفا فیلدها را مجددا چک کنید",
              severity: "error",
            });
            break;
          default:
            setAlert({
              alertCheck: true,
              message: t("alert_defualt"),
              severity: "error",
            });
        }
        setProDis(false);
        setLoading(false);
      });
  };

  const images = [imageResize1, imageResize2, imageResize3, imageResize4];
  const sendImage = async (proId) => {
    setLoading(true);
    setProDis(true);
    const AuthStr = "Bearer " + localStorage.getItem("TACC");
    try {
      for (let index = 0; index < images.length; index++) {
        if (images[index] !== null) {
          const formData = new FormData();
          formData.append("prop", "I");
          formData.append("product_id", proId);
          formData.append("image", images[index]);

          await axios({
            url: baseUrl + "/api/v1/product/set",
            method: "POST",
            headers: {
              Authorization: AuthStr,
              "Content-Type": "multipart/form-data",
            },
            data: formData,
          });
        }
      }

      setAlert({
        alertCheck: true,
        message: `محصول شما با شناسه ${proId} ثبت شد`,
        severity: "success",
      });
      const timeout = setTimeout(() => {
        window.location.reload();
      }, 5000);
      return () => {
        clearTimeout(timeout);
      };
    } catch (error) {
      const { status } = error.response;
      switch (status) {
        case 500:
          setAlert({
            alertCheck: true,
            message: t("AM_intervalServer"),
            severity: "error",
          });
          break;
        case 400:
          setAlert({
            alertCheck: true,
            message: "درخواست نامعتبر است،لطفا فیلدها را مجددا چک کنید",
            severity: "error",
          });
          break;
        default:
          setAlert({
            alertCheck: true,
            message: t("alert_defualt"),
            severity: "error",
          });
      }
    } finally {
      setProDis(false);
      setLoading(false);
      window.location.reload();
    }
  };

  // const addCommas = (num) =>
  //   num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

  const replaceNumber = (value, la) => {
    value = value.toString();
    if (la === "fa") {
      value = value.replace(".", "/");
    }
    return value;
  };

  const separator = (value) => {
    value = value.toString();
    var place = 0;
    if (value.includes(".")) {
      place = value.indexOf(".");
      var num1 = value.slice(0, place);
      var num2 = value.slice(place + 1, value.length);
      value = camaInsert(num1, false) + "." + camaInsert(num2, true);
    } else {
      value = camaInsert(value);
    }
    return value;
  };

  function camaInsert(value, after = false) {
    var output = [];
    var outputString = "";
    if (after) {
      for (var i = 1; i <= value.length; i++) {
        if (i % 3 === 0) {
          output.push(value.slice(i - 3, i));
        }
      }
      if (value.length % 3 !== 0) {
        output.push(
          value.slice(value.length - (value.length % 3), value.length),
        );
      }

      for (var j = 0; j < output.length; j++) {
        if (j + 1 < output.length) {
          outputString = outputString + output[j] + ",";
        } else {
          outputString = outputString + output[j];
        }
      }
    } else {
      for (var p = 1; p <= value.length; p++) {
        if (p % 3 === 0) {
          output.push(value.slice(value.length - p, value.length - p + 3));
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(0, value.length % 3));
      }
      for (var o = output.length - 1; o >= 0; o--) {
        if (o > 0) {
          outputString = outputString + output[o] + ",";
        } else {
          outputString = outputString + output[o];
        }
      }
    }
    return outputString;
  }

  const stringValue = (value) => {
    var output = "";
    value = value.toString();
    value = value.split(",");
    for (var i = 0; i < value.length; i++) {
      output += value[i].toString();
    }
    output = output.replace("/", ".");
    return output;
  };

  const onlyFloatnaumber = (value) => {
    value = value.trim();
    value = stringValue(value);
    var regex = new RegExp("^[0-9]*[.]*[0-9]*$");
    if (regex.test(value)) {
      if (value[0] !== "0") {
        return value;
      } else {
        if (value.length === 1) {
          return value;
        } else {
          if (value.length === 2) {
            if (value[0] === "0" && value[1] === ".") {
              return value;
            } else {
              if (value[0] === "0" && value[1] !== ".") {
                return value[1];
              }
            }
          } else {
            if (value.length > 2) {
              if (value.substr(2).includes(".")) {
                return value[0] + value[1];
              } else {
                return value;
              }
            }
          }
        }
      }
    } else {
      return "";
    }
  };

  const priceHandler = (event) => {
    let value = onlyFloatnaumber(event.target.value);
    setPrice(value);
  };

  const handleCloseM = (e, selectedProduct) => {
    setProduct(selectedProduct);
    if (selectedProduct) {
      let filter;
      if (selectedProduct) {
        filter = proData.find((item) => item.id === selectedProduct.id);
      }
      if (filter) {
        const selectedBrand = {
          value: filter.brand.name_fa || "",
          id: filter.brand.id,
        };
        setBrand(selectedBrand);
        setBrandId(filter.brand.id);
        const selectedModel = {
          value: filter.model.name || "",
          id: filter.model.id,
        };
        setModel(selectedModel);
        setModelId(filter.model.id);
        const selectedRegion = {
          value: filter.regin.name_fa || "",
          id: filter.regin.id,
        };
        setRegion(selectedRegion);
        setRegionId(filter.regin.id);
        const selectedSize = {
          value: `${filter.size.inch || ""}_${filter.size.pixel || ""}`,
          id: filter.size.id,
        };
        setSize(selectedSize);
        setSizeId(filter.size.id);
        const selectedColor = {
          value: filter.color.name_fa || "",
          id: filter.color.id,
        };
        setColor(selectedColor);
        setColorId(filter.color.id);
        setOs(filter.os || "");
        setProccess(filter.proccess || "");
        setNetwork(filter.network || "");
        setYear(filter.lunch || "");
        setWeight(filter.weight || "");
        setSim(filter.sim || "");
        setDisplay(filter.type_display || "");
        setRam(filter.ram || "");
        setZarfiat(filter.hdd || "");
        setGraphic(filter.vga || "");
        setMainCameraFeature(filter.main_camera_fea || "");
        setMainCameraResolution(filter.main_camera_mou || "");
        setMainCameraVideo(filter.main_camera_vid || "");
        setSelfiCameraFeature(filter.selfi_camera_fea || "");
        setSelfiCameraResolution(filter.selfi_camera_mou || "");
        setSelfiCameraVideo(filter.selfi_camera_vid || "");
        setBattery(filter.battery || "");
        setCharge(filter.charging || "");
      }
    }
  };

  return (
    <>
      <Grid
        sx={{
          display: "flex",
          width: "100%",
          height: "100%",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          direction: i18n.language === "fa" ? "rtl" : "ltr",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "90%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Autocomplete
            value={product}
            onChange={handleCloseM}
            options={productSelect}
            getOptionLabel={(option) => (option ? option.value || "" : "")}
            renderOption={(props, option) => (
              <Typography component={"li"} {...props} key={option.id}>
                {option.value}
              </Typography>
            )}
            size="medium"
            sx={{
              width: { xs: "80%", sm: "90%", md: "80%", xl: "50%" },
              "& .MuiInputBase-root fieldset": {
                borderRadius: "14px",
                borderColor: "#FF3951",
              },
              backgroundColor: "white",
              borderRadius: "14px",
              "& .MuiAutocomplete-endAdornment": {
                left:
                  i18n.language === "fa"
                    ? "7px !important"
                    : "unset !important",
                right:
                  i18n.language === "fa"
                    ? "unset !important"
                    : "7px !important",
              },
              "& .MuiMenuItem-root": { justifyContent: "flex-end" },
              "& .MuiSvgIcon-root": { color: "text.greenLight" },
            }}
            renderInput={(params) => (
              <TextField
                className="textField"
                label="کپی از اطلاعات قبلی"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                }}
              />
            )}
            isOptionEqualToValue={(option, value) => {
              if (!value) return false;
              return option.id === value.id;
            }}
          />
          <Typography sx={{ margin: "5px 0px 5px 0px" }}>
            جهت کپی اطلاعات دسته را انتخاب کنید.
          </Typography>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
            marginTop: "20px",
          }}
        >
          <Grid style={{ display: "flex", alignItems: "center" }}>
            <Autocomplete
              value={group}
              onChange={onchangeGroup}
              options={groupSelect}
              getOptionLabel={(option) => (option ? option.value || "" : "")}
              renderOption={(props, option) => (
                <Typography component={"li"} {...props}>
                  {option.value}
                </Typography>
              )}
              size="medium"
              sx={{
                width: {
                  xs: "200px",
                  sm: "350px",
                  md: "200px",
                  lg: "300px",
                  xl: "500px",
                },
                "& .MuiInputBase-root fieldset": { borderRadius: "14px" },
                backgroundColor: "white",
                borderRadius: "14px",
                "& .MuiAutocomplete-endAdornment": {
                  left:
                    i18n.language === "fa"
                      ? "7px !important"
                      : "unset !important",
                  right:
                    i18n.language === "fa"
                      ? "unset !important"
                      : "7px !important",
                },
                "& .MuiMenuItem-root": { justifyContent: "flex-end" },
                "& .MuiSvgIcon-root": { color: "text.greenLight" },
              }}
              renderInput={(params) => (
                <TextField
                  className="textField"
                  label="انتخاب دسته"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => {
                if (!value) return false;
                return option.id === value.id;
              }}
            />
            <Typography
              onClick={() => openModalHandler("addGroup")}
              sx={{
                color: "#FF3951",
                fontWeight: "bold",
                paddingRight: "5px",
                fontSize: {
                  xs: "8px",
                  sm: "12px",
                  md: "8px",
                  lg: "12px",
                  xl: "20px",
                },
                cursor: "pointer",
              }}
            >
              افزودن +
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              marginTop: { xs: "10px", md: "unset" },
            }}
          >
            <Autocomplete
              value={brand}
              onChange={onchangeBrand}
              options={brandSelect}
              getOptionLabel={(option) => (option ? option.value || "" : "")}
              renderOption={(props, option) => (
                <Typography component={"li"} {...props}>
                  {option.value}
                </Typography>
              )}
              size="medium"
              sx={{
                width: {
                  xs: "200px",
                  sm: "350px",
                  md: "200px",
                  lg: "300px",
                  xl: "500px",
                },
                "& .MuiInputBase-root fieldset": { borderRadius: "14px" },
                backgroundColor: "white",
                borderRadius: "14px",
                "& .MuiAutocomplete-endAdornment": {
                  left:
                    i18n.language === "fa"
                      ? "7px !important"
                      : "unset !important",
                  right:
                    i18n.language === "fa"
                      ? "unset !important"
                      : "7px !important",
                },
                "& .MuiMenuItem-root": { justifyContent: "flex-end" },
                "& .MuiSvgIcon-root": { color: "text.greenLight" },
              }}
              renderInput={(params) => (
                <TextField
                  className="textField"
                  label="انتخاب برند"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => {
                if (!value) return false;
                return option.id === value.id;
              }}
            />
            <Typography
              onClick={() => openModalHandler("addBrand")}
              sx={{
                color: "#FF3951",
                fontWeight: "bold",
                paddingRight: "5px",
                fontSize: {
                  xs: "8px",
                  sm: "12px",
                  md: "8px",
                  lg: "12px",
                  xl: "20px",
                },
                cursor: "pointer",
              }}
            >
              افزودن +
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
            marginTop: "20px",
          }}
        >
          <Grid style={{ display: "flex", alignItems: "center" }}>
            <Autocomplete
              value={model}
              onChange={onchangeModel}
              options={modelSelect}
              getOptionLabel={(option) => (option ? option.value || "" : "")}
              renderOption={(props, option) => (
                <Typography component={"li"} {...props}>
                  {option.value}
                </Typography>
              )}
              size="medium"
              sx={{
                width: {
                  xs: "200px",
                  sm: "350px",
                  md: "200px",
                  lg: "300px",
                  xl: "500px",
                },
                "& .MuiInputBase-root fieldset": { borderRadius: "14px" },
                backgroundColor: "white",
                borderRadius: "14px",
                "& .MuiAutocomplete-endAdornment": {
                  left:
                    i18n.language === "fa"
                      ? "7px !important"
                      : "unset !important",
                  right:
                    i18n.language === "fa"
                      ? "unset !important"
                      : "7px !important",
                },
                "& .MuiMenuItem-root": { justifyContent: "flex-end" },
                "& .MuiSvgIcon-root": { color: "text.greenLight" },
              }}
              renderInput={(params) => (
                <TextField
                  className="textField"
                  label="انتخاب مدل"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => {
                if (!value) return false;
                return option.id === value.id;
              }}
            />
            <Typography
              onClick={() => openModalHandler("addModel")}
              sx={{
                color: "#FF3951",
                fontWeight: "bold",
                paddingRight: "5px",
                fontSize: {
                  xs: "8px",
                  sm: "12px",
                  md: "8px",
                  lg: "12px",
                  xl: "20px",
                },
                cursor: "pointer",
              }}
            >
              افزودن +
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              marginTop: { xs: "10px", md: "unset" },
            }}
          >
            <Autocomplete
              value={region}
              onChange={onchangeRegion}
              options={regionSelect}
              getOptionLabel={(option) => (option ? option.value || "" : "")}
              renderOption={(props, option) => (
                <Typography component={"li"} {...props}>
                  {option.value}
                </Typography>
              )}
              size="medium"
              sx={{
                width: {
                  xs: "200px",
                  sm: "350px",
                  md: "200px",
                  lg: "300px",
                  xl: "500px",
                },
                "& .MuiInputBase-root fieldset": { borderRadius: "14px" },
                backgroundColor: "white",
                borderRadius: "14px",
                "& .MuiAutocomplete-endAdornment": {
                  left:
                    i18n.language === "fa"
                      ? "7px !important"
                      : "unset !important",
                  right:
                    i18n.language === "fa"
                      ? "unset !important"
                      : "7px !important",
                },
                "& .MuiMenuItem-root": { justifyContent: "flex-end" },
                "& .MuiSvgIcon-root": { color: "text.greenLight" },
              }}
              renderInput={(params) => (
                <TextField
                  className="textField"
                  label="انتخاب سرزمین"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => {
                if (!value) return false;
                return option.id === value.id;
              }}
            />
            <Typography
              onClick={() => openModalHandler("addRegion")}
              sx={{
                color: "#FF3951",
                fontWeight: "bold",
                paddingRight: "5px",
                fontSize: {
                  xs: "8px",
                  sm: "12px",
                  md: "8px",
                  lg: "12px",
                  xl: "20px",
                },
                cursor: "pointer",
              }}
            >
              افزودن +
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
            marginTop: "20px",
          }}
        >
          <Grid style={{ display: "flex", alignItems: "center" }}>
            <Autocomplete
              value={size}
              onChange={onchangeSize}
              options={sizeSelect}
              getOptionLabel={(option) => (option ? option.value || "" : "")}
              renderOption={(props, option) => (
                <Typography component={"li"} {...props}>
                  {option.value}
                </Typography>
              )}
              size="medium"
              sx={{
                width: {
                  xs: "200px",
                  sm: "350px",
                  md: "200px",
                  lg: "300px",
                  xl: "500px",
                },
                "& .MuiInputBase-root fieldset": { borderRadius: "14px" },
                backgroundColor: "white",
                borderRadius: "14px",
                "& .MuiAutocomplete-endAdornment": {
                  left:
                    i18n.language === "fa"
                      ? "7px !important"
                      : "unset !important",
                  right:
                    i18n.language === "fa"
                      ? "unset !important"
                      : "7px !important",
                },
                "& .MuiMenuItem-root": { justifyContent: "flex-end" },
                "& .MuiSvgIcon-root": { color: "text.greenLight" },
              }}
              renderInput={(params) => (
                <TextField
                  className="textField"
                  label="انتخاب سایز"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => {
                if (!value) return false;
                return option.id === value.id;
              }}
            />
            <Typography
              onClick={() => openModalHandler("addSize")}
              sx={{
                color: "#FF3951",
                fontWeight: "bold",
                paddingRight: "5px",
                fontSize: {
                  xs: "8px",
                  sm: "12px",
                  md: "8px",
                  lg: "12px",
                  xl: "20px",
                },
                cursor: "pointer",
              }}
            >
              افزودن +
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              marginTop: { xs: "10px", md: "unset" },
            }}
          >
            <Autocomplete
              value={color}
              onChange={onchangeColor}
              options={colorSelect}
              getOptionLabel={(option) => (option ? option.value || "" : "")}
              renderOption={(props, option) => (
                <Typography component={"li"} {...props}>
                  {option.value}
                </Typography>
              )}
              size="medium"
              sx={{
                width: {
                  xs: "200px",
                  sm: "350px",
                  md: "200px",
                  lg: "300px",
                  xl: "500px",
                },
                "& .MuiInputBase-root fieldset": { borderRadius: "14px" },
                backgroundColor: "white",
                borderRadius: "14px",
                "& .MuiAutocomplete-endAdornment": {
                  left:
                    i18n.language === "fa"
                      ? "7px !important"
                      : "unset !important",
                  right:
                    i18n.language === "fa"
                      ? "unset !important"
                      : "7px !important",
                },
                "& .MuiMenuItem-root": { justifyContent: "flex-end" },
                "& .MuiSvgIcon-root": { color: "text.greenLight" },
                // width: { xs: "228px", sm: "400px", md: "231px", lg: "350px", xl: "580px" },
                marginLeft: {
                  xs: "1.8em",
                  sm: "2.8em",
                  md: "2em",
                  lg: "3em",
                  xl: "4.9em",
                },
              }}
              renderInput={(params) => (
                <TextField
                  className="textField"
                  label="انتخاب رنگ"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => {
                if (!value) return false;
                return option.id === value.id;
              }}
            />
            {/* <Typography onClick={() => openModalHandler("addColor")} sx={{ color: "#FF3951", fontWeight: "bold", paddingRight: "5px", fontSize: { xs: "8px", sm: "12px", md: "8px", lg: "12px", xl: "20px" }, cursor: "pointer" }}>افزودن +</Typography> */}
          </Grid>
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "4em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="نوع پردازنده"
            className="textField"
            variant="outlined"
            fullWidth
            value={proccess}
            onChange={(e) => setProccess(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="نوع سیستم عامل"
            className="textField"
            variant="outlined"
            fullWidth
            value={os}
            onChange={(e) => setOs(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
          <TextField
            placeholder="شبکه های مخابراتی"
            className="textField"
            variant="outlined"
            fullWidth
            value={network}
            onChange={(e) => setNetwork(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="سال معرفی"
            className="textField"
            variant="outlined"
            fullWidth
            value={year}
            onChange={(e) => setYear(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="وزن"
            className="textField"
            variant="outlined"
            fullWidth
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
          <TextField
            placeholder="تعداد سیم کارت"
            className="textField"
            variant="outlined"
            fullWidth
            value={sim}
            onChange={(e) => setSim(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="فناوری صفحه نمایشگر"
            className="textField"
            variant="outlined"
            fullWidth
            value={display}
            onChange={(e) => setDisplay(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="رم"
            className="textField"
            variant="outlined"
            fullWidth
            value={ram}
            onChange={(e) => setRam(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
          <TextField
            placeholder="ظرفیت داخلی"
            className="textField"
            variant="outlined"
            fullWidth
            value={zarfiat}
            onChange={(e) => setZarfiat(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="گرافیک"
            className="textField"
            variant="outlined"
            fullWidth
            value={graphic}
            onChange={(e) => setGraphic(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="رزولوشن دوربین اصلی"
            className="textField"
            variant="outlined"
            fullWidth
            value={mainCameraResolution}
            onChange={(e) => setMainCameraResolution(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
          <TextField
            placeholder="ویژگی های دوربین اصلی"
            className="textField"
            variant="outlined"
            fullWidth
            value={mainCameraFeature}
            onChange={(e) => setMainCameraFeature(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="حالت فیلم برداری دوربین اصلی"
            className="textField"
            variant="outlined"
            fullWidth
            value={mainCameraVideo}
            onChange={(e) => setMainCameraVideo(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="رزولوشن دوربین سلفی"
            className="textField"
            variant="outlined"
            fullWidth
            value={selfiCameraResolution}
            onChange={(e) => setSelfiCameraResolution(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
          <TextField
            placeholder="ویژگی های دوربین سلفی"
            className="textField"
            variant="outlined"
            fullWidth
            value={selfiCameraFeature}
            onChange={(e) => setSelfiCameraFeature(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="حالت فیلم برداری دوربین سلفی"
            className="textField"
            variant="outlined"
            fullWidth
            value={selfiCameraVideo}
            onChange={(e) => setSelfiCameraVideo(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="باتری"
            className="textField"
            variant="outlined"
            fullWidth
            value={battery}
            onChange={(e) => setBattery(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
          <TextField
            placeholder="شارژ"
            className="textField"
            variant="outlined"
            fullWidth
            value={charge}
            onChange={(e) => setCharge(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="قیمت"
            className="textField"
            variant="outlined"
            fullWidth
            value={replaceNumber(separator(price), i18n.language)}
            onChange={priceHandler}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="title فارسی"
            className="textField"
            variant="outlined"
            fullWidth
            value={title_fa}
            onChange={(e) => setTitle_fa(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
              overflowX: "scroll",
            }}
          />
          <TextField
            placeholder="title انگلیسی"
            className="textField"
            variant="outlined"
            fullWidth
            value={title_en}
            onChange={(e) => setTitle_en(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="توضیحات گوشی"
            className="textField"
            variant="outlined"
            fullWidth
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="h1 فارسی"
            className="textField"
            variant="outlined"
            fullWidth
            value={h1_fa}
            onChange={(e) => setH1_fa(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
          <TextField
            placeholder="h1 انگلیسی"
            className="textField"
            variant="outlined"
            fullWidth
            value={h1_en}
            onChange={(e) => setH1_en(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="description فارسی"
            className="textField"
            variant="outlined"
            fullWidth
            value={desc_fa}
            onChange={(e) => setDesc_fa(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <TextField
            placeholder="description انگلیسی"
            className="textField"
            variant="outlined"
            fullWidth
            value={desc_en}
            onChange={(e) => setDesc_en(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
          <TextField
            placeholder="meta-keyword فارسی"
            className="textField"
            variant="outlined"
            fullWidth
            value={keyword_fa}
            onChange={(e) => setKeyword_fa(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          />
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <TextField
            placeholder="meta-keyword انگلیسی"
            className="textField"
            variant="outlined"
            fullWidth
            value={keyword_en}
            onChange={(e) => setKeyword_en(e.target.value)}
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
            }}
          />
          <Grid
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              height: "50px",
              borderRadius: "8px",
              backgroundColor: "white",
              border: " 0.7px solid #B9B9B9",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center",
              padding: "0 10px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          >
            {img1 === null ? (
              <Typography
                sx={{ fontSize: { xs: "12px", md: "16px" }, color: "gray" }}
              >
                اضافه کردن عکس1
              </Typography>
            ) : (
              <Typography
                component={"img"}
                src={img1}
                sx={{ width: "40px", height: "40px" }}
              ></Typography>
            )}
            <Input
              id="upload-photo-card1"
              type="file"
              sx={{ display: "none" }}
              accept="image/*"
              onChange={(e) => onChangeLicence(e, "IMG1")}
            />
            <Grid
              component={"label"}
              htmlFor="upload-photo-card1"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "white",
                borderRadius: "8px",
                width: { xs: "38px", md: "53px" },
                height: { xs: "30px", md: "43px" },
              }}
            >
              <CloudUploadOutlinedIcon
                sx={{ color: "red", fontSize: { xs: "17px", md: "24px" } }}
              />
            </Grid>
          </Grid>
          <Grid
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              height: "50px",
              borderRadius: "8px",
              backgroundColor: "white",
              border: " 0.7px solid #B9B9B9",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center",
              padding: "0 10px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          >
            {img2 === null ? (
              <Typography
                sx={{ fontSize: { xs: "12px", md: "16px" }, color: "gray" }}
              >
                اضافه کردن عکس2
              </Typography>
            ) : (
              <Typography
                component={"img"}
                src={img2}
                sx={{ width: "40px", height: "40px" }}
              ></Typography>
            )}
            <Input
              id="upload-photo-card2"
              type="file"
              sx={{ display: "none" }}
              accept="image/*"
              onChange={(e) => onChangeLicence(e, "IMG2")}
            />
            <Grid
              component={"label"}
              htmlFor="upload-photo-card2"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "white",
                borderRadius: "8px",
                width: { xs: "38px", md: "53px" },
                height: { xs: "30px", md: "43px" },
              }}
            >
              <CloudUploadOutlinedIcon
                sx={{ color: "red", fontSize: { xs: "17px", md: "24px" } }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          sx={{
            marginTop: { xs: "20px", md: "1.5em" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "90%",
            justifyContent: { xs: "unset", md: "space-between" },
            alignItems: { xs: "center", md: "unset" },
          }}
        >
          <Grid
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              height: "50px",
              borderRadius: "8px",
              backgroundColor: "white",
              border: " 0.7px solid #B9B9B9",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center",
              padding: "0 10px",
            }}
          >
            {img3 === null ? (
              <Typography
                sx={{ fontSize: { xs: "12px", md: "16px" }, color: "gray" }}
              >
                اضافه کردن عکس3
              </Typography>
            ) : (
              <Typography
                component={"img"}
                src={img3}
                sx={{ width: "40px", height: "40px" }}
              ></Typography>
            )}
            <Input
              id="upload-photo-card3"
              type="file"
              sx={{ display: "none" }}
              accept="image/*"
              onChange={(e) => onChangeLicence(e, "IMG3")}
            />
            <Grid
              component={"label"}
              htmlFor="upload-photo-card3"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "white",
                borderRadius: "8px",
                width: { xs: "38px", md: "53px" },
                height: { xs: "30px", md: "43px" },
              }}
            >
              <CloudUploadOutlinedIcon
                sx={{ color: "red", fontSize: { xs: "17px", md: "24px" } }}
              />
            </Grid>
          </Grid>
          <Grid
            sx={{
              width: { xs: "230px", sm: "400px", md: "30%" },
              height: "50px",
              borderRadius: "8px",
              backgroundColor: "white",
              border: " 0.7px solid #B9B9B9",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center",
              padding: "0 10px",
              marginTop: { xs: "20px", md: "unset" },
            }}
          >
            {img4 === null ? (
              <Typography
                sx={{ fontSize: { xs: "12px", md: "16px" }, color: "gray" }}
              >
                اضافه کردن عکس4
              </Typography>
            ) : (
              <Typography
                component={"img"}
                src={img4}
                sx={{ width: "40px", height: "40px" }}
              ></Typography>
            )}
            <Input
              id="upload-photo-card4"
              type="file"
              sx={{ display: "none" }}
              accept="image/*"
              onChange={(e) => onChangeLicence(e, "IMG4")}
            />
            <Grid
              component={"label"}
              htmlFor="upload-photo-card4"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "white",
                borderRadius: "8px",
                width: { xs: "38px", md: "53px" },
                height: { xs: "30px", md: "43px" },
              }}
            >
              <CloudUploadOutlinedIcon
                sx={{ color: "red", fontSize: { xs: "17px", md: "24px" } }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Button
            onClick={addProduct}
            disabled={proDis}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              padding: "0px 2px",
              marginTop: "2em",
              "&:hover": { backgroundColor: "#FF3951" },
              backgroundColor: "#FF3951",
              width: { xs: "100px", md: "200px" },
              height: { xs: "35px", md: "50px" },
              borderRadius: "25px",
            }}
          >
            <Typography
              component={"p"}
              sx={{ color: "white", fontSize: "17px", fontWeight: "bold" }}
            >
              {proDis === true && loading === true ? (
                <CircularProgress
                  size={20}
                  color="inherit"
                  sx={{ color: "white" }}
                />
              ) : (
                "افزودن"
              )}
            </Typography>
          </Button>
        </Grid>
        <Modal
          open={openModal}
          onClose={() => closeModal()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Grid
            onClick={(e) => clickOtherLocation(e)}
            id="modal-status"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(105,99,99,0.6)",
              direction: i18n.language === "fa" ? "rtl" : "ltr",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                background: "#FFFFFF",
                width: { xs: "95%", sm: "674px" },
                borderRadius: "12px",
                padding: "10px 0 20px 0",
              }}
            >
              <Typography
                sx={{
                  marginTop: "10px",
                  fontSize: { xs: "15px", sm: "17px", lg: "20px", xl: "22px" },
                }}
              >
                در این بخش اطلاعات مربوطه را وارد کنید.
              </Typography>
              <Grid
                sx={{
                  display: modalType === "addModel" ? "flex" : "none",
                  width: "90%",
                  marginTop: "1.5em",
                  justifyContent: "center",
                }}
              >
                <TextField
                  placeholder="افزودن نام مدل (انگلیسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addModel}
                  onChange={(e) => setAddModel(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                  }}
                />
              </Grid>
              <Grid
                sx={{
                  display: modalType === "addBrand" ? "flex" : "none",
                  width: "90%",
                  marginTop: "1.5em",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <TextField
                  placeholder="افزودن برند (فارسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addBrand_fa}
                  onChange={(e) => setAddBrand_fa(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                  }}
                />
                <TextField
                  placeholder="افزودن برند (انگلیسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addBrand_en}
                  onChange={(e) =>
                    setAddBrand_en(convertCapital(e.target.value))
                  }
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                    marginTop: "1.5em",
                  }}
                />
                <TextField
                  placeholder="توضیحات برند"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addDesc}
                  multiline
                  onChange={(e) => setAddDesc(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                    marginTop: "1.5em",
                  }}
                />
              </Grid>
              <Grid
                sx={{
                  display: modalType === "addGroup" ? "flex" : "none",
                  width: "90%",
                  marginTop: "1.5em",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <TextField
                  placeholder="افزودن دسته (فارسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addGroup_fa}
                  onChange={(e) => setAddGroup_fa(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                  }}
                />
                <TextField
                  placeholder="افزودن دسته (انگلیسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addGroup_en}
                  onChange={(e) =>
                    setAddGroup_en(convertCapital(e.target.value))
                  }
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                    marginTop: "1.5em",
                  }}
                />
              </Grid>
              <Grid
                sx={{
                  display: modalType === "addRegion" ? "flex" : "none",
                  width: "90%",
                  marginTop: "1.5em",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <TextField
                  placeholder="افزودن سرزمین (فارسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addRegion_fa}
                  onChange={(e) => setAddRegion_fa(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                  }}
                />
                <TextField
                  placeholder="افزودن سرزمین (انگلیسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addRegion_en}
                  onChange={(e) =>
                    setAddRegion_en(convertCapital(e.target.value))
                  }
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                    marginTop: "1.5em",
                  }}
                />
              </Grid>
              <Grid
                sx={{
                  display: modalType === "addSize" ? "flex" : "none",
                  width: "90%",
                  marginTop: "1.5em",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <TextField
                  placeholder="افزودن سایز(اینچ)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addSize}
                  onChange={(e) => setAddSize(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                  }}
                />
                <TextField
                  placeholder="افزودن سایز(پیکسل)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addPixel}
                  onChange={(e) => setAddPixel(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                    marginTop: "1.5em",
                  }}
                />
              </Grid>
              <Grid
                sx={{
                  display: modalType === "addColor" ? "flex" : "none",
                  width: "90%",
                  marginTop: "1.5em",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <TextField
                  placeholder="افزودن رنگ (فارسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addColor_fa}
                  // onChange={(e) => setCondition(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                  }}
                />
                <TextField
                  placeholder="افزودن رنگ (انگلیسی)"
                  className="textField"
                  variant="outlined"
                  fullWidth
                  value={addColor_en}
                  // onChange={(e) => setCondition(e.target.value)}
                  sx={{
                    width: "80%",
                    background: "#FFFFFF",
                    marginTop: "1.5em",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "8px",
                  }}
                />
                {/* <TextField placeholder="افزودن رنگ (hex)"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={addHex}
                  // onChange={(e) => setCondition(e.target.value)}
                  sx={{
                    width: "80%", background: "#FFFFFF", marginTop: "1.5em",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                /> */}
              </Grid>
              <Button
                onClick={() => submitHandler(modalType)}
                disabled={btnDis}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0px 2px",
                  marginTop: "1.5em",
                  "&:hover": { backgroundColor: "#FF3951" },
                  backgroundColor: "#FF3951",
                  width: { xs: "100px", md: "150px" },
                  height: { xs: "35px", md: "50px" },
                  borderRadius: "25px",
                }}
              >
                <Typography
                  component={"p"}
                  sx={{ color: "white", fontSize: "17px", fontWeight: "bold" }}
                >
                  {btnDis === true && loading === true ? (
                    <CircularProgress
                      size={20}
                      color="inherit"
                      sx={{ color: "white" }}
                    />
                  ) : (
                    "افزودن"
                  )}
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Modal>
        <AlertMessage
          open={alert.alertCheck}
          message={alert.message}
          duration={3000}
          close={handleClose}
          severity={alert.severity}
        />
      </Grid>
    </>
  );
}
